import { useMemo } from "react";
import ValidationError from "../../ZodError";
import { TransitionProgress } from "../schemas/TransitionProgressSchemas";
import { createErrorState, createLoadingState, createSuccessState, } from "../utils/hookStateHelpers";
import { calculateTransitionProgress } from "../utils/transitionProgressCalculator";
import useTransitionTasks from "./useTransitionTasks";
const TASK_TYPE_ORDER = [
    "TRANSITION_KICKOFF",
    "TRANSITION_LAUNCH",
    "TRANSITION_POST_LAUNCH",
];
const useTransitionProgress = (transitionId, auth) => {
    const tasksQuery = useTransitionTasks(transitionId, auth);
    const processedData = useMemo(() => {
        if (!tasksQuery.data) {
            return undefined;
        }
        try {
            const filteredLevel1Tasks = tasksQuery.data.level1Tasks.filter((task) => task.taskType !== "TRANSITION_ADVISOR_ONBOARDING");
            const filteredLevel2Tasks = tasksQuery.data.level2Tasks.filter((task) => task.taskType !== "TRANSITION_ADVISOR_ONBOARDING");
            const sortedLevel1Tasks = [...filteredLevel1Tasks].sort((a, b) => {
                const aIndex = TASK_TYPE_ORDER.indexOf(a.taskType);
                const bIndex = TASK_TYPE_ORDER.indexOf(b.taskType);
                // If both tasks are in the order array, sort by their position
                if (aIndex !== -1 && bIndex !== -1) {
                    return aIndex - bIndex;
                }
                // If only one task is in the order array, prioritize it
                if (aIndex !== -1) {
                    return -1;
                }
                if (bIndex !== -1) {
                    return 1;
                }
                // If neither task is in the order array, maintain original order
                return 0;
            });
            const rawData = calculateTransitionProgress(tasksQuery.data.transitionTaskId, sortedLevel1Tasks, filteredLevel2Tasks);
            const validationResult = TransitionProgress.safeParse(rawData);
            if (validationResult.success) {
                return validationResult.data;
            }
            else {
                console.error("TransitionProgress validation failed:", validationResult.error);
                throw new ValidationError("Invalid transition progress data", validationResult.error.issues);
            }
        }
        catch (error) {
            console.error("Error calculating transition progress:", error);
            return undefined;
        }
    }, [tasksQuery.data]);
    if (tasksQuery.hasError) {
        return createErrorState(tasksQuery.error);
    }
    if (tasksQuery.isLoading) {
        return createLoadingState();
    }
    if (processedData !== undefined) {
        return createSuccessState(processedData);
    }
    return createErrorState(new Error("Unable to calculate transition progress"));
};
export default useTransitionProgress;
//# sourceMappingURL=useTransitionProgress.js.map